(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/* global require module axios */

const globals = require("./globals");
const utils = require("./utils");

function getColors() {
  return [
    "#d70206",
    "#f05b4f",
    "#f4c63d",
    "#d17905",
    "#453d3f",
    "#59922b",
    "#0544d3",
    "#6b0392",
    "#f05b4f",
    "#dda458",
    "#eacf7d",
    "#86797d",
    "#b2c326",
    "#6188e2",
    "#a748ca",
    "#d70206",
    "#f05b4f",
    "#f4c63d",
    "#d17905",
    "#453d3f",
    "#59922b",
    "#0544d3",
    "#6b0392",
    "#f05b4f",
    "#dda458",
    "#eacf7d",
    "#86797d",
    "#b2c326",
    "#6188e2",
    "#a748ca"
  ];
}

function getPercentage(quantity, totalQuantity) {
  return (quantity * 100) / totalQuantity;
}

function createLabels(labels, colors) {
  let list = "";
  for (let i = 0; i < labels.length; i++) {
    list += `<li class="chart-legend"><span class="shape-circle" style="background-color: ${
      colors[i]
    };"></span>${labels[i]}</li>`;
  }
  return list;
}

function addCircleElement(svg, label, color, percentage, dashoffset) {
  var svgNS = svg.namespaceURI;
  var title = document.createElementNS(svgNS, "title");
  var circle = document.createElementNS(svgNS, "circle");
  title.textContent = label;
  circle.setAttribute("cx", 21);
  circle.setAttribute("cy", 21);
  circle.setAttribute("class", "donut-segment");
  circle.setAttribute("fill", "transparent");
  circle.setAttribute("r", "15.91549430918954");
  circle.setAttribute("stroke", color);
  circle.setAttribute("stroke-width", "5");
  circle.setAttribute(
    "stroke-dasharray",
    percentage.toString() + " " + (100 - percentage).toString()
  );
  circle.setAttribute("stroke-dashoffset", dashoffset);
  circle.appendChild(title);
  svg.appendChild(circle);
  return dashoffset;
}

function getChartTemplate() {
  return `
    <div class=chart-container>
        <svg width="100%" height="100%" viewBox="0 0 42 42" class="donut">
            <circle class="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="#fff"></circle>
            <g class="chart-text">
                <text x="50%" y="50%" class="chart-number" font-size="14" text-anchor="middle" dy="5px">
                </text>
            </g>
        </svg>
        <ul class="chart-desc">
        </ul>
    </div>`;
}

function appendListeners(el, queryTitle = "") {
  utils.forEach(el.querySelectorAll(".chart-legend"), function(index, legend) {
    legend.addEventListener("click", function() {
      var re = /.+?(?=:)/;
      var collName = re.exec(this.innerText);
      var catalogUrl = "";
      catalogUrl =
        globals.catalog +
        "&filter%5B%5D=actual_site_facet%3A" +
        encodeURIComponent(queryTitle);
      catalogUrl +=
        "&filter%5B%5D=~origin_library_facet%3A" + encodeURIComponent(collName);
      window.open(catalogUrl, "_blank");
    });
  });
}

var drawChart = function(data, el, colors, callback) {
  var series = data[1].map(Number);
  var labels = data[0];
  labels = labels.map(function(item, index) {
    return item + ": " + series[index] + " sv.";
  });
  var total = series.reduce(function(sum, value) {
    return sum + value;
  }, 0);

  el.querySelector(".chart-number").textContent = total;
  el.querySelector(".chart-desc").innerHTML = createLabels(labels, colors);

  var startingOffset = 25;
  var dashoffset = startingOffset;
  var precedingsLength = 0;
  for (let i = 0; i < series.length; i++) {
    addCircleElement(
      el.querySelector("svg"),
      labels[i],
      colors[i],
      getPercentage(series[i], total),
      dashoffset
    );
    precedingsLength = precedingsLength + getPercentage(series[i], total);
    dashoffset = 100 - precedingsLength + startingOffset;
  }

  callback();
};

var prepareChartData = function(queryTitle, hashValue) {
  axios
    .get(globals.ajaxUrl + "chart-data/?title_535=" + queryTitle)
    .then(function(response) {
      if (!response.data.length) {
        document.querySelector("." + hashValue + " .ct-chart").innerText =
          globals.langStrings.noResults;
        return;
      }
      var labels = [];
      var series = [];
      var chartData = [];

      for (var i = 0; i < response.data.length; i++) {
        labels.push(response.data[i].title);
        series.push(response.data[i].count);
      }

      chartData.push(labels, series);

      document.querySelector(
        "." + hashValue + " .ct-chart"
      ).innerHTML = getChartTemplate();
      drawChart(
        chartData,
        document.querySelector("." + hashValue + " .ct-chart"),
        getColors(),
        function() {
          appendListeners(
            document.querySelector("." + hashValue + " .ct-chart"),
            queryTitle
          );
        }
      );
    })
    .catch(function() {
      document.querySelector("." + hashValue + " .ct-chart").innerText =
        globals.langStrings.notLoad;
    });
};

var getFilteredCollSum = function(queryTitle, hashValue) {
  var url;
  if (
    !utils.getParamByNameMulti("origin_library_facet").length &&
    !utils.getParamByNameMulti("former_owner_facet").length &&
    !utils.getParamByNameMulti("actual_site_facet").length
  ) {
    url = globals.ajaxUrl + "count-records/?title_535=" + queryTitle;
  } else {
    url =
      globals.ajaxUrl +
      "count-records/" +
      window.location.search +
      "&title_535=" +
      queryTitle;
  }

  axios
    .get(url)
    .then(function(response) {
      document.querySelector("." + hashValue + " .count-records").innerText =
        response.data;
    })
    .catch(function(error) {
      console.log(error);
    });
};

module.exports = {
  prepareChartData,
  getFilteredCollSum
};

},{"./globals":3,"./utils":6}],2:[function(require,module,exports){
/* global module require ga */

const utils = require("./utils");
const globals = require("./globals");
const leafletMap = require("./map");

document
  .querySelector(".map-sidebar .close")
  .addEventListener("click", function() {
    document.querySelector(".map-sidebar").classList.add("hidden");
    document.querySelector(".open-btn").style.display = "inline-block";
    document.querySelector(".open-btn").style.visibility = "visible";
  });

document
  .querySelector(".map-sidebar .open-btn")
  .addEventListener("click", function() {
    document.querySelector(".map-sidebar").classList.remove("hidden");
    document.querySelector(".open-btn").style.display = "none";
  });

utils.forEach(document.querySelectorAll(".map-sidebar .title"), function(
  index,
  el
) {
  el.addEventListener("click", function() {
    utils.toggleBlock(this.nextElementSibling);
  });
});

utils.forEach(document.querySelectorAll(".map-sidebar .icons .map"), function(
  index,
  el
) {
  el.addEventListener("click", function() {
    let gps = this.dataset.gps.split(",");
    leafletMap.map.flyTo(gps, leafletMap.maxZoom);
  });
});

document.querySelector(".overlay-close").addEventListener("click", function() {
  closeOverlay();
});

document.querySelector("#search").addEventListener("click", function() {
  location.replace(utils.changeParameter());
});

document
  .getElementById("language-switcher")
  .addEventListener("click", function(e) {
    e.preventDefault();
    document.cookie = "_icl_current_language=" + globals.langCode + "; path=/";
    window.location.reload(true);
  });

document.querySelector("#catalog").addEventListener("click", function() {
  let url = globals.catalog;
  let orig = utils.getParamByNameMulti("origin_library_facet");
  let former = utils.getParamByNameMulti("former_owner_facet");
  let actual = utils.getParamByNameMulti("actual_site_facet");

  if (former.length) {
    former.map(function(item) {
      url +=
        "&filter%5B%5D=former_owner_facet%3A%22" + encodeURIComponent(item);
    });
  }

  if (orig.length) {
    orig.map(function(item) {
      url +=
        "&filter%5B%5D=~origin_library_facet%3A" + encodeURIComponent(item);
    });
  }

  if (actual.length) {
    url += "&filter%5B%5D=actual_site_facet%3A" + encodeURIComponent(actual[0]);
  }

  window.open(url, "_blank");
});

var openOverlay = function(title, query, postId, hashValue) {
  if (postId === undefined) {
    postId = false;
  }
  window.location.hash = hashValue;

  if (typeof ga !== "undefined") {
    ga("send", "pageview", { page: location.hash });
  }

  if (postId) {
    utils.getSinglePost(postId);
  } else {
    document.querySelector(".overlay-header").textContent = title;
  }
  document.querySelector("#overlay").style.display = "block";
  document.querySelector(".site-container").style.display = "none";
  leafletMap.map.closePopup();
};

var closeOverlay = function() {
  window.location.hash = "";
  document.querySelector("#overlay").style.display = "none";
  document.querySelector(".site-container").style.display = "block";
  document.querySelector(".overlay-header").innerHTML = "&nbsp;";
  document.querySelector(".overlay-content").innerHTML = "";
};

var locationHashChange = function() {
  var hashValue = window.location.hash;
  hashValue = hashValue.substring(1);

  if (hashValue) {
    globals.locations.forEach(function(item) {
      if (item.hashValue == hashValue) {
        openOverlay(item.query, item.query, item.post_id, item.hashValue);
        return;
      }
    });
  }
};

module.exports = {
  closeOverlay,
  locationHashChange
};

},{"./globals":3,"./map":4,"./utils":6}],3:[function(require,module,exports){
/* global module */

const catalog = document.querySelector("#mapid").dataset.catalog;
const locations = JSON.parse(document.getElementById("locations").innerHTML);
const baseUrl = document.querySelector("#mapid").dataset.url;
const ajaxUrl = document.querySelector("#mapid").dataset.ajax;
const apiUrl = ajaxUrl + "destinations/";
const token =
  "pk.eyJ1IjoiamFya2EiLCJhIjoiY2tnanoyYjhwMDRqdDJ4b3pkYXJpMzkzZSJ9.N4BhtERhg1EG_X9amItvqg";
const langStrings = JSON.parse(document.getElementById("langs").innerHTML);
const langCode = document.querySelector("#mapid").dataset.language;

const popupSettings = {
  maxWidth: 320,
  minWidth: 320,
  autoPan: false
};

module.exports = {
  apiUrl,
  catalog,
  locations,
  baseUrl,
  ajaxUrl,
  popupSettings,
  token,
  langStrings,
  langCode
};

},{}],4:[function(require,module,exports){
/* global module L require axios */
const globals = require("./globals");
const utils = require("./utils");
const chart = require("./chart");
const maxZoom = 7;

const map = L.map("mapid", {
  center: L.latLng(51.65892664880053, 11.271972656250002),
  zoom: 5,
  maxZoom: maxZoom,
  minZoom: 4,
  maxBounds: L.latLngBounds(L.latLng(24.83, -35.1), L.latLng(82.5, 84.5))
});

const tileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    id: 'mapbox/light-v10',
    accessToken: globals.token
});

tileLayer.addTo(map);

map.on("popupopen", function(e) {
  let px = map.project(e.popup._latlng);
  px.y -= e.popup._container.clientHeight / 2;
  map.panTo(map.unproject(px), { animate: true });
});

const circleIcon = L.icon({
  iconUrl: globals.baseUrl + "assets/images/map-marker.png",
  iconSize: [32, 47],
  iconAnchor: [16, 47]
});

const prepareMarkers = function() {
  let allMarkers = [];

  globals.locations.forEach(function(item) {
    let singleMarker = L.marker([item.gps[0], item.gps[1]], {
      icon: circleIcon
    })
      .bindTooltip(item.query, item.hashValue)
      .bindPopup(getPopupContent(item.query, item.hashValue, item.post_id), {
        maxWidth: globals.popupSettings.maxWidth,
        minWidth: globals.popupSettings.minWidth,
        className: item.hashValue,
        autoPan: globals.popupSettings.autoPan
      })
      .on("click", function() {
        chart.prepareChartData(item.query, item.hashValue);
      });
    allMarkers.push(singleMarker);
  });
  let group = new L.featureGroup(allMarkers);
  group.addTo(map);
  map.fitBounds(group.getBounds().pad(0.05));
};

const prepareMarker = function(index, item) {
  L.marker([item.gps[0], item.gps[1]], { icon: circleIcon })
    .addTo(map)
    .bindTooltip(item.query)
    .bindPopup(
      getPopupContent(item.query, item.hashValue, item.post_id, true),
      {
        maxWidth: globals.popupSettings.maxWidth,
        minWidth: globals.popupSettings.minWidth,
        className: item.hashValue,
        autoPan: globals.popupSettings.autoPan
      }
    )
    .on("click", function() {
      chart.getFilteredCollSum(item.query, item.hashValue);
      chart.prepareChartData(item.query, item.hashValue);
    });
};

const getPopupContent = function(title, hash, postId, sum = false) {
  let button = `<button class="btn btn-primary btn-sm" onclick="window.location.hash = '${hash}'">${
    globals.langStrings.more
  }</button>`;
  return `
    <div class="popup-header">
        <h3>${title}</h3>
        ${postId ? button : ""}
    </div>
    ${
      sum
        ? `
        <h4 style="margin-top: 0.5em;">Počet nalezených svazků: <span class="count-records"></span></h4>
        `
        : `
        `
    }
    
    <h4>${globals.langStrings.provenanceStructure}</h4>
    <div class="ct-chart"></div>
    `;
};

const changeVisibility = function() {
  if (
    !utils.getParamByNameMulti("origin_library_facet").length &&
    !utils.getParamByNameMulti("former_owner_facet").length &&
    !utils.getParamByNameMulti("actual_site_facet").length
  ) {
    prepareMarkers();
    return;
  } else {
    axios
      .get(globals.ajaxUrl + "filter-locations/" + window.location.search)
      .then(function(response) {
        let dataArr = Object.keys(response.data).map(function(key) {
          return response.data[key];
        });

        globals.locations.forEach(function(item, index) {
          if (utils.include(dataArr, item.query)) {
            prepareMarker(index, item);
          }
        });

        utils.forEach(document.querySelectorAll("#actual-site li"), function(
          index,
          el
        ) {
          if (!utils.include(dataArr, el.querySelector("input").value)) {
            el.classList.add("disabled-item");
          }
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

module.exports = {
  map,
  circleIcon,
  prepareMarkers,
  prepareMarker,
  changeVisibility,
  maxZoom
};

},{"./chart":1,"./globals":3,"./utils":6}],5:[function(require,module,exports){
/* global module */

const globals = require("./globals");

var renderPostTemplate = function(data) {
  if (data.title == null) {
    return `
        <div class="overlay-sidebar">
            ${globals.langStrings.dataNotLoad}
        </div>
        `;
  }
  return `
        <div class="overlay-sidebar">
            <ul class="list-none">
                ${
                  data.korist_adresa
                    ? `
                    <li>${data.korist_adresa}</li>
                    `
                    : `
                    `
                }
                ${
                  data.korist_url
                    ? `
                    <li><a target="_blank" href="${
                      data.korist_url
                    }">WWW</a></li>
                    `
                    : `
                    `
                }
            </ul>
        </div>

        <div class="overlay-desc">
            <div class="text-container">
                ${data.content}
            </div>

            <div class="img-container">
                <a href="${data.korist_preview}" target="_blank">
                    <img src="${data.korist_preview}" alt="${
    data.title
  }" title="${data.title}">
                </a>
            </div>

            <div class="text-container">
                <h4>${globals.langStrings.literature}</h4>
                ${data.korist_literatura}
            </div>

        </div>
    `;
};

module.exports = {
  renderPostTemplate
};

},{"./globals":3}],6:[function(require,module,exports){
/* global require module axios */

const globals = require("./globals");
const template = require("./template");

var forEach = function(nodeList, callback, scope) {
  for (var i = 0; i < nodeList.length; i++) {
    callback.call(scope, i, nodeList[i]);
  }
};

var ready = function(fn) {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

var toggleBlock = function(el) {
  el.style.display = el.style.display == "none" ? "block" : "none";
};

var changeParameter = function() {
  var actualSite = document.querySelectorAll(
    '#actual-site input[type="checkbox"]:checked'
  );
  var origLibrary = document.querySelectorAll(
    '#orig-library input[type="checkbox"]:checked'
  );
  var formerOwner = document.querySelectorAll(
    '#former-owner input[type="checkbox"]:checked'
  );
  var par = serializeParam({
    actual_site_facet: getCheckedValues(actualSite),
    origin_library_facet: getCheckedValues(origLibrary),
    former_owner_facet: getCheckedValues(formerOwner)
  });
  return globals.baseUrl + "?" + par + window.location.hash;
};

var getCheckedValues = function(checkedArr) {
  var checked = [];
  for (var i = 0; i < checkedArr.length; i++) {
    checked.push(checkedArr[i].value);
  }
  return checked;
};

var getParamByNameMulti = function(paramName, url) {
  if (!url) url = window.location.href;
  var params = [];
  if (url.indexOf("?") > 0) {
    var arrParams = url.split("?");
    var arrURLParams = arrParams[1].split("&");
    for (var i = 0; i < arrURLParams.length; i++) {
      var sParam = arrURLParams[i].split("=");
      if (sParam) {
        if (sParam[0] == paramName) {
          if (sParam.length > 0) {
            if (sParam[1].slice(-1) == "#") {
              sParam[1] = sParam[1].substring(0, sParam[1].length - 1);
            }
            sParam[1] = decodeURIComponent(sParam[1].replace(/\+/g, " "));
            params.push(sParam[1].trim());
          }
        }
      }
    }
  }
  return params;
};

var serializeParam = function(params) {
  var url = [];
  Object.keys(params).map(function(param) {
    for (var i = 0; i < params[param].length; i++) {
      url.push(
        param +
          "=" +
          encodeURIComponent(params[param][i]).replace(/%(20)/g, "+")
      );
    }
  });
  return url.join("&");
};

var showSearchFilters = function(className) {
  var checkboxes = [].slice.call(
    document.querySelectorAll('.map-sidebar .legend input[type="checkbox"]')
  );
  var params = flattenArr([
    getParamByNameMulti("actual_site_facet"),
    getParamByNameMulti("origin_library_facet"),
    getParamByNameMulti("former_owner_facet")
  ]);
  checkboxes.map(function functionName(item) {
    if (include(params, item.value)) {
      forEach(document.querySelectorAll("." + className), function(index, el) {
        el.insertAdjacentHTML(
          "afterbegin",
          `
                    <div class="badge remove-filter">
                        <span>${item.value}</span>
                        <img src="${
                          globals.baseUrl
                        }assets/images/delete.svg" title="${
            globals.langStrings.removeFilter
          }" alt="${globals.langStrings.removeFilter}" height="12" width="12">
                    </div>
                    `
        );
      });

      item.setAttribute("checked", "true");
    }
  });

  if (document.querySelector("." + className).children.length) {
    document
      .querySelector("." + className)
      .insertAdjacentHTML(
        "beforeend",
        '<div id="filter-clear"><span class="badge">' +
          globals.langStrings.removeFilters +
          "</span></div>"
      );
  }
  forEach(document.querySelectorAll(".search-filters .remove-filter"), function(
    index,
    item
  ) {
    item.addEventListener("click", function() {
      var valToRemove = item.querySelector("span").innerText;
      checkboxes.map(function functionName(item) {
        if (item.value == valToRemove) {
          item.checked = false;
          location.replace(changeParameter());
          return;
        }
      });
    });
  });

  if (document.querySelector("#filter-clear")) {
    document
      .querySelector("#filter-clear")
      .addEventListener("click", function() {
        location.replace(globals.baseUrl);
      });
  }
};

var include = function(arr, obj) {
  return arr.indexOf(obj) != -1;
};

var flattenArr = function(arr) {
  return arr.reduce(function(a, b) {
    return a.concat(b);
  }, []);
};

var getSinglePost = function(postId) {
  axios
    .get(globals.apiUrl + postId)
    .then(function(response) {
      document.querySelector(".overlay-header").textContent =
        response.data.title;
      document.querySelector(
        ".overlay-content"
      ).innerHTML = template.renderPostTemplate(response.data);
    })
    .catch(function(e) {
      console.log(e);
      document.querySelector(".overlay-content").innerHTML =
        globals.langStrings.dataNotLoad;
    });
};

module.exports = {
  forEach,
  ready,
  toggleBlock,
  changeParameter,
  getCheckedValues,
  getParamByNameMulti,
  serializeParam,
  showSearchFilters,
  include,
  flattenArr,
  getSinglePost
};

},{"./globals":3,"./template":5}],7:[function(require,module,exports){
/* global require */

const controls = require("./libs/controls");

const utils = require("./libs/utils");
const leafletMap = require("./libs/map");

function init() {
  leafletMap.changeVisibility();
  utils.showSearchFilters("search-filters");

  utils.forEach(document.querySelectorAll(".sidebar .legend .map"), function(
    index,
    el
  ) {
    el.addEventListener("click", function() {
      let gps = el.dataset.gps.split(",");
      leafletMap.map.flyTo([parseFloat(gps[0]), parseFloat(gps[1])], 7);
    });
  });

  utils.forEach(document.querySelectorAll(".sidebar .legend label"), function(
    index,
    el
  ) {
    el.addEventListener("click", function() {
      if (this.previousElementSibling.checked) {
        this.previousElementSibling.checked = false;
      } else {
        this.previousElementSibling.checked = true;
      }
    });
  });
}

window.onhashchange = controls.locationHashChange;
window.onload = controls.locationHashChange;

utils.ready(init);

},{"./libs/controls":2,"./libs/map":4,"./libs/utils":6}]},{},[7]);
